import React, { useState } from 'react';
import ConfirmModal from '../../UI/Modal/confirmModal';
import { deleteSpecificTealiumProduct } from '../../../utils/APIs';
import { useUserContext } from '../../../contexts/UserContext';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const DeleteTealiumAudienceStream = ({ setDeleteIntegration, id, setActionLoading, setConfirmModal }) => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

    const [error,setErrors]=useState({
        active:'',
        deactivate:'',
        delete:''
    });
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDeleteProduct = async(id)=>{
        try {
            setActionLoading(true);
            setIsDeleting(true);
            const result =  await  deleteSpecificTealiumProduct(userData.token, userData.selectedOrganization.org_token ,id)
            if (result) {
                setDeleteIntegration(false);
                setConfirmModal({
                    active:false,
                    deactivate:false,
                    delete:true
                })
            }
        } catch (error) {
           setErrors({  deactivate:'', delete: error?.message , active : ''})            
        } finally {
            setActionLoading(false);
            setIsDeleting(false);
        }
    }
    return (
        <ConfirmModal
            title={content.DELETE_TEALIUM_INTEGRATION_MODAL.title}
            description={content.DELETE_TEALIUM_INTEGRATION_MODAL.description_1}
            ConfirmText={content.DELETE_TEALIUM_INTEGRATION_MODAL.formLabels.deactivate_integration_cta}
            error={error.delete}
            loading={isDeleting}
            hideModal={() => setDeleteIntegration(false)}
            handleConfirmation={() => handleDeleteProduct(id)}
        />
    )
}

export default DeleteTealiumAudienceStream;